<style>
/* ===============================
   Auth Background
================================ */

.auth-wrapper {
  min-height: 100vh;
  background: url("https://images.unsplash.com/photo-1615873968403-89e068629265") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.auth-overlay {
  position: absolute;
  inset: 0;
  background: rgba(43, 47, 76, 0.7);
}

/* ===============================
   Auth Card
================================ */

.auth-card {
  position: relative;
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.25);
  z-index: 1;
}

/* ===============================
   Welcome
================================ */

.auth-welcome h2 {
  color: #2b2f4c;
  font-weight: 700;
}

.auth-welcome p {
  color: #6b7280;
  font-size: 14px;
}

/* ===============================
   Toggle Buttons
================================ */

.auth-toggle {
  display: flex;
  background: #f1f5f9;
  border-radius: 10px;
  overflow: hidden;
}

.auth-toggle button {
  flex: 1;
  padding: 10px;
  border: none;
  background: transparent;
  font-weight: 600;
  color: #2b2f4c;
  cursor: pointer;
}

.auth-toggle button.active {
  background: #2b2f4c;
  color: #ffffff;
}

/* ===============================
   Forms
================================ */

.auth-form label {
  font-size: 14px;
  font-weight: 600;
  color: #2b2f4c;
}

.auth-form input {
  height: 44px;
  border-radius: 8px;
}

.auth-link{
  text-decoration: none !important;
  color: var(--dark-blue);
}

.btn-mod{
  font-size: 16px;
  text-align: center;
  justify-content: center;
  color:#ffffff;
  background-color: #2b2f4c;
}

.btn-mod:hover{
  color: #11D452;
  border:none
}

.text-error{
  color: rgb(250 85 56);
}

@media (max-width: 767.98px) {

  .auth-card {
    width:80% !important;
    padding: 30px 15px;
    border-radius: 10px;
  }
 
}
</style>

<template>

  <div class="auth-wrapper">
    <div class="auth-overlay"></div>

    <div class="auth-card">

        <!-- Welcome -->
        <div class="auth-welcome text-center mb-4">
            <h2>Welcome Back 👋</h2>
            <!--p>Login or create an account to continue shopping</p-->
        </div>

         
        <span class="text-error">{{ this.$store.state.errors }}</span>
      

        <!-- Login Form -->
        <form id="loginForm" @submit.prevent="login" class="auth-form">
            <h6 class="text-danger" id="error_message"></h6>
            <!--div id="loading-login" class="loading-hiden">
                    <img class="center-block" width="340" src="/images/cupertino.gif" alt="#" />
                </div-->
            <div class="mb-3">
                <label>Username</label>
                <input type="text"  v-model="this.form.username" id="phone" class="form-control" placeholder="Enter phone">
            </div>

            <div class="mb-3">
                <label>Password</label>
                <input type="password" v-model="this.form.password" id="password" class="form-control" placeholder="Enter password">
            </div>

            <button type="submit" id="login_btn" class="btn-primary-icon-light btn-mod w-100 mt-3 mb-3">
                <i class="fas fa-sign-in-alt me-1"></i> Login
            </button>

            <div class="d-flex justify-content-between text-sm">
        <a href="#" class="text-blue-600 hover:underline">
          
        </a>
        <a href="#" class="text-blue-600 hover:underline">
          Forgot Password?
        </a>
      </div>
        </form>

    </div>
</div>


</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      errors: "",
      alert_danger:false,
      alert_success:false,
      alert_load:false,
      change_pass_btn: true,
      message:"",
      username:"",
      auth:true,
      form: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    async forgetPassword(){
        var username = this.username

        this.alert_load = true
        this.alert_danger = false
        this.alert_success = false

        var response = await axios.post(this.$store.state.api_url + "/forget-password-request",{username})
        .catch((errors) => {
        this.alert_load = false
        var message = "Network or Server Errors";
        this.$toast.error(message,{duration: 7000,dismissible: true,})
        });
    
        if (response.data.success) {
            this.alert_load = false
            if(response.data.status == 1){
                this.alert_success = true
                this.alert_danger = false
                this.message = response.data.message
            }
            if(response.data.status == 2){
                this.alert_danger = true
                this.alert_success = false
                this.message = response.data.message
            }
            if(response.data.status == 3){
              alert(response.data.message)
                //alert("If you don't receive SMS, Wait for 10min then try again")
            }   
    
        } else {
            this.alert_load = false
            console.log(response.data.errors)
        }
                
    
    },
    login() {
      this.$store.dispatch("loginUser", this.form);
    },
  },
  created() {},
};
</script>